import React from "react";
import { Card, CardBody } from "reactstrap";
import { Images, TooltipWrapper } from "@workspace/common";
import { useSelector } from "react-redux";

function OfferCreationCountCard({ setStatus }) {
  const preOfferCounts = useSelector(
    (state) => state.PreOfferCandidateReducer.counts
  );
  const slaCounts = useSelector(
    (state) => state.PreOfferCandidateReducer.slaCounts
  );

  return (
    <Card className="offer-creation-item mb-0">
      <CardBody className="elc-cardbody">
        <div className="elc-tile-header">
          <img src={Images.icons.property_1_2} className="elc-title-icon" />
          <span className="elc-tile-title">Offer Creation</span>
        </div>
        <div className={"d-flex align-items-start w-100 flex-row gap-3"}>
          {/* Approved Count */}
          <TooltipWrapper tooltipText="Offer Created">
            <div
              className="d-flex flex-row align-items-center gap-2 cursor-pointer"
              onClick={() => {
                setStatus("CREATE_OFFER");
              }}
            >
              <div className="approved-count-circle">
                <span className="mdi mdi-check elc-check-icon"></span>
              </div>
              <span className="approved-count">
                {preOfferCounts?.createOfferCount ?? 0}
              </span>
            </div>
          </TooltipWrapper>
          {/* Pending Count */}
          <TooltipWrapper tooltipText="Offer Creation Pending">
            <div
              className="d-flex flex-row align-items-center gap-2 cursor-pointer"
              onClick={() => {
                setStatus("CREATE_OFFER_PENDING");
              }}
            >
              <div className="pending-count-circle">
                <span className="mdi mdi-message-alert-outline elc-pending-icon"></span>
              </div>
              <span className="pending-count">
                {preOfferCounts?.createOfferPendingCount ?? 0}
              </span>
            </div>
          </TooltipWrapper>
          {/* Correction needed Count */}
          <TooltipWrapper tooltipText="Correction Needed in Offer">
            <div
              className="d-flex flex-row align-items-center gap-2 cursor-pointer"
              onClick={() => {
                setStatus("CORRECTION_NEEDED");
              }}
            >
              <div className="revised-count-circle">
                <span className="mdi mdi-refresh elc-revised-icon"></span>
              </div>
              <span className="revised-count">
                {preOfferCounts?.offerCorrectionNeededCount ?? 0}
              </span>
            </div>
          </TooltipWrapper>
          {/* SLA Count */}
          <TooltipWrapper tooltipText="SLA">
            <div
              className="d-flex flex-row align-items-center gap-2 cursor-pointer"
              onClick={() => {
                setStatus("CREATE_OFFER_SLA");
              }}
            >
              <div className="sla-count-circle">
                <span className="mdi mdi-clock-alert-outline elc-alert-icon"></span>
              </div>
              <span className="sla-count">
                {slaCounts?.createOfferSLACount ?? 0}
              </span>
            </div>
          </TooltipWrapper>
        </div>
      </CardBody>
    </Card>
  );
}

export default OfferCreationCountCard;
